module.exports = __webpack_public_path__ + "img/bidirectional_online.691c4054.png";